import { FaHouseDamage } from "react-icons/fa";

export default FaHouseDamage;